import AccountCancelFreeMonthPage from './AccountCancelFreeMonthPage'

export default AccountCancelFreeMonthPage
// eslint-disable-next-line import/export
export * from './AccountCancelFreeMonthPage'
